
































import {Component, PropSync} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {SelectWings, ToggleWings} from 'wings-ui-components';

import { ManagementServicesFilter } from '@/store/mail_notify/management_services/types';
import BaseFilter from "@/components/Filter/BaseFilter";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings}})
export default class MNManagementServicesFilter extends BaseFilter<ManagementServicesFilter> {

  @PropSync("show") is_show!: boolean;

  @Action("getManagementServices") actionGetManagementServices: any;
  @Action('getPartners') actionGetPartners: any;

  defaultFilter(): ManagementServicesFilter {
    return {
      partner: undefined,
    };
  }

  partnersList: any = [];

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Mail Notify service",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetManagementServices(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

}
